"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.trackCartCheckoutStep = void 0;
const trackGA4EventWithCleanUp_1 = require("../trackGA4EventWithCleanUp");
const enums_1 = require("../../enums");
function trackCartCheckoutStep(step, clickUrl, clickText) {
    (0, trackGA4EventWithCleanUp_1.trackGA4EventWithCleanUp)({
        eventData: {
            eventName: enums_1.GA4EventName.ClickTextLink,
            feature_category: enums_1.GA4FeatureCategory.Cart,
            click_element: `step ${step} cart`,
            click_text: clickText,
            click_url: clickUrl,
        },
    });
}
exports.trackCartCheckoutStep = trackCartCheckoutStep;
//# sourceMappingURL=trackCartCheckoutStep.js.map